function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(9828 13445.999)"
}, React.createElement("path", {
  d: "M-9760.85-13399.217c-1.661-2.445-10.555-2.72-19.843-.608s-15.481 5.8-13.812 8.245c.759 1.118 3.052 1.781 6.191 1.965l-21.161 13.484 2.005 1.582 24.565-15.154a59.049 59.049 0 008.244-1.27c9.298-2.109 15.481-5.8 13.811-8.244z",
  opacity: 0.207
}), React.createElement("ellipse", {
  cx: 2.925,
  cy: 1.795,
  rx: 2.925,
  ry: 1.795,
  transform: "translate(-9813.644 -13379.778)",
  fill: "#888"
}), React.createElement("path", {
  d: "M-9813.643-13422.81v43.8c0 .986 1.162 1.786 2.7 1.786s2.7-.8 2.7-1.786v-43.8z",
  fill: "#fff"
}), React.createElement("g", {
  transform: "translate(-9828 -13445.999)",
  fill: "#5fce17",
  stroke: "#9de56e",
  strokeWidth: 4
}, React.createElement("circle", {
  cx: 16.718,
  cy: 16.718,
  r: 16.718,
  stroke: "none"
}), React.createElement("circle", {
  cx: 16.718,
  cy: 16.718,
  r: 14.718,
  fill: "none"
})), React.createElement("path", {
  d: "M-9824.066-13421.28c5.468 3.87 12.176 4.363 17.511 1.283 6.115-3.53 9.008-10.96 7.2-18.49.259.378.507.773.737 1.172 4.595 7.96 2.488 17.81-4.696 21.958-6.821 3.938-15.936 1.336-20.752-5.923z",
  fill: "#57bf14",
  opacity: 0.371
}));

var SvgMapPin = function SvgMapPin(props) {
  return React.createElement("svg", _extends({
    width: 72.012,
    height: 76.04
  }, props), _ref);
};

export default SvgMapPin;